import script from "./SportEventList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportEventList.vue?vue&type=script&setup=true&lang=ts"

import "./SportEventList.vue?vue&type=style&index=0&id=463c422e&lang=scss"

const __exports__ = script;

export default __exports__